export class AddTypeBO {
  id: string = "00000000-0000-0000-0000-000000000000";
  statusLid: string;
  statusLovName: string;
  typeName: string;
  typeNumber: any;
  typeFor: string;
}
export class GetListBasetype {
  statusLid: string | null;
  SearchColumn: string = "typeName";
  SearchText: string = "";
  orderColumn: string = "typeName";
  orderType: string = "asc";
  pageitem: number = 10;
  currentpageno: number = 1;
  field: string = "typeName";
  value: string = "";
  matchCase: boolean = false;
  operator: string = "startswith"
  type: string = "string";
  typeFor: string;
}
export class WhereCondition {
  field: string = "typeName";
  value: string = "";
  operator: string = "startswith";
  orderNo: number = 1;
  predicate: string = "and";
  type: string = "string";
  matchCase: boolean = false;
}
// ...........................................notes.........................................................................

export class AddNoteBO {
  id: string = "00000000-0000-0000-0000-000000000000";
  date: string;
  notes: string;
  typeListIds: string[];
  typeListId: string = "00000000-0000-0000-0000-000000000000";
  referralId: string = "00000000-0000-0000-0000-000000000000";
  agencyId: string = "00000000-0000-0000-0000-000000000000";
  // user: string
  // multipletype: [];
  initial: string;
}

export class GetListBasenote {
  SearchColumn: string = "typeListName";
  SearchText: string = "";
  orderColumn: string = "typeListName";
  orderType: string = "asc";
  pageitem: number = 10;
  currentpageno: number = 1;
  userId: string = "00000000-0000-0000-0000-000000000000";
  field: string = "typeListName";
  value: string = "";
  matchCase: boolean = false;
  operator: string = "startswith";
  type: string = "string";
  startDate: string | null;
  endDate: string | null;
  typeListId: string = "00000000-0000-0000-0000-000000000000";
  referralId:  string = "00000000-0000-0000-0000-000000000000";
}
export class WhereConditionnote {
  field: string = "typeListName";
  value: string = "";
  operator: string = "startswith";
  orderNo: number = 1;
  predicate: string = "and";
  type: string = "string";
  matchCase: boolean = false;
}
